module.exports = __webpack_public_path__ + "img/bonus_dark_en.85ef278a.svg";